import {FC} from "react";

import styles from "./OrganizationBadge.module.scss";
import Image from "next/image";
import Link from "next/link";
import {mainPath} from "@/app/routes/MainPath";
import VerificationPledge from "@/shared/VerificationPledge";
import classNames from "classnames";
interface OrganizationBadgeProps {
  className?: string;
  name: string;
  slug: string;
  logo: string;
  isVerified: boolean;
}

const OrganizationBadge: FC<OrganizationBadgeProps> = ({ className, name, slug, logo, isVerified }) => {
  return (
    <div className={classNames(styles.root, className)}>
      <Image
        width={56}
        height={56}
        className={styles.root__poster}
        src={logo}
        alt={name}
      />
      <div className={styles.root__col}>
        <Link
          className={styles.root__link}
          href={`${mainPath.organization.path}/${slug}`}>
          {name}
        </Link>
        <VerificationPledge is_verified={isVerified}/>
      </div>
    </div>
  );
};

export default OrganizationBadge;
